module.exports = __webpack_public_path__ + "c064cdca2711e7261b90547f1f9b59ee.png";


//////////////////
// WEBPACK FOOTER
// ../images/icons/icon-download.png
// module id = 1095
// module chunks = 69